import { render, staticRenderFns } from "./JoszakiCheckbox.vue?vue&type=template&id=8450b98e"
import script from "./JoszakiCheckbox.vue?vue&type=script&lang=js"
export * from "./JoszakiCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports